import {Async, Loaded, Loading } from 'Core/models/Async';

export class UnassignedUnderwriter {
    
    public readonly key = 'UnassignedUnderwriter';
  }

export type Underwriter = Async<string[]> | UnassignedUnderwriter;

type MatchUnderwriterOptions<TReturn> = {
    Loading: () => TReturn;
    Loaded: (underwriter: string[]) => TReturn;
    Error: () => TReturn;
    Unassigned: (underwriter: []) => TReturn;
  };

export const isLoading = (underwriter: Underwriter): underwriter is Loading<string[]> =>
    underwriter.key === 'Loading';

export const isLoaded = (underwriter: Underwriter): underwriter is Loaded<string[]> => underwriter.key === 'Loaded';
export const isUnassignedUnderwriter = (underwriter: Underwriter): underwriter is UnassignedUnderwriter => underwriter.key === 'UnassignedUnderwriter';

export const matchUnderwriter = <TReturn>(options: MatchUnderwriterOptions<TReturn>) => (
    underwriter: Underwriter
  ) => {
  
    switch (underwriter.key) {
      case 'UnassignedUnderwriter':
        return options.Unassigned([]);
      case 'Loaded':
        return options.Loaded(underwriter.Data);
      case 'Loading':
        return options.Loading();
      case 'Conflict':
        return options.Error();
      case 'ServerError':
        return options.Error();
      case 'Unauthorized':
        return options.Error();
    }
  };
  